import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui-icons/Close';
import ReactPlayer from 'react-player';

class OfferMedia extends React.Component {
  state = {
    open: false,
    url: '',
  };

  setUrlAndOpen = (url) => {
    this.setState({ url, open: true });
  };

  handleClose = () => {
    this.setState({ url: '', open: false });
  };

  generatedThumbnail = (url) => {
    const youtubeVideo = url.match(
      /(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))([^&"'>]+)/
    );

    if (youtubeVideo) {
      const youtubeId = youtubeVideo[5];

      if (youtubeId) {
        return `https://img.youtube.com/vi/${youtubeId}/0.jpg`;
      }
    }

    return false;
  };

  render() {
    const { videoFiles } = this.props;

    return (
      Boolean(videoFiles && videoFiles.length) && (
        <Fragment>
          <div className='max-width-div'>
            <div className='black-44'>Media</div>
            <div className='docu-card-wrapper'>
              {videoFiles &&
                videoFiles.map((video) => (
                  <div key={video.url} className='docu-card-container'>
                    <div
                      className='card-docu-preview video'
                      style={
                        this.generatedThumbnail(video.url)
                          ? {
                              backgroundImage: `url(${this.generatedThumbnail(
                                video.url
                              )})`,
                              backgroundSize: 'cover',
                            }
                          : {
                              backgroundImage: `url(${video.imageUrl}), linear-gradient(180deg, #44546a, #44546a)`,
                              backgroundSize: 'cover',
                            }
                      }
                    />
                    <p className='card-docu-title'>{video.title}</p>
                    <button
                      onClick={() => this.setUrlAndOpen(video.url)}
                      className='btn-download w-inline-block'
                    >
                      Watch
                    </button>
                  </div>
                ))}
            </div>
          </div>
          <Dialog fullScreen open={this.state.open} onClose={this.handleClose}>
            <Toolbar>
              <IconButton color='inherit' onClick={this.handleClose}>
                <CloseIcon />
              </IconButton>
            </Toolbar>

            <div className='video-outer-container'>
              <div className='video-inner-container'>
                <ReactPlayer
                  className='video-player'
                  //url='https://www.facebook.com/earthescapevids/videos/764858494045462/'
                  url={this.state.url}
                  playing
                  controls
                  config={{
                    file: {
                      attributes: {
                        crossOrigin: 'false',
                      },
                    },
                  }}
                />
              </div>
            </div>
          </Dialog>
        </Fragment>
      )
    );
  }
}

OfferMedia.propTypes = {
  videoFiles: PropTypes.array.isRequired,
};

export default OfferMedia;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/OfferMedia.js